//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

// AUTH
export const LOGIN_URL = "/api/v1/account/auth/login"
export const FORGOT_PASSWORD = "/api/v1/account/auth/forgot-password"
export const OTP_VERIFICATION =
  "/api/v1/account/auth/verify-forgot-password-otp"
export const CHANGE_PASSWORD = "/api/v1/account/auth/change-password"
export const GET_PROFILE_DETAILS = "/api/v1/profile"
export const VERIFY_AND_LOGIN = "/api/v1/account/auth/verify-and-login"
export const RESEND_VERIFY_OTP = "/api/v1/account/auth/resend-verify-otp"
export const RESET_PASSWORD = "/api/v1/account/change-password"

// CANDIDATE UPDATE DETAILS
export const UPDATE_GENERAL_DETAILS =
  "/api/v1/profile/update-general-information"
export const UPDATE_BANK_DETAILS = "/api/v1/profile/update-bank-information"
export const UPDATE_JOB_APPLICATION_DETAILS =
  "/api/v1/profile/update-job-application-information"
export const UPLOAD_PROFILE_DOCUMENT = "/api/v1/profile/upload-documents"
export const ASSETS_DELIVERY_CONFIRMATION =
  "/api/v1/profile/id-cards/assets/update"

// JOB APPLICATION/CANDIDATES
export const GET_JOB_APPLICATION = "/api/v1/admin/candidate/list"
export const GET_JOB_APPLICATION_DETAILS = "/api/v1/profile"
export const GET_AVAILABLE_SLOTS = "/api/v1/profile/interview/available-slots"
export const INTERVIEW_APPLY = "/api/v1/profile/interview/apply"
export const GET_CANDIDATE_THEORETICAL_AVAILABLE =
  "/api/v1/profile/theoretical/available"
export const CANDIDATE_ACCEPT_THEORETICAL = "/api/v1/profile/theoretical/accept"
export const CANDIDATE_ACCEPT_PRACTICAL = "/api/v1/profile/practical/accept"
export const CANDIDATE_INTERVIEW_REJECT = "/api/v1/profile/interview/reject"

// INTERVIEW SCHEDULE MANAGEMENT
export const GET_INTERVIEW_SCHEDULE_LIST =
  "/api/v1/admin/interview/schedule/list"
export const CREATE_INTERVIEW_SCHEDULE =
  "/api/v1/admin/interview/schedule/store"
export const GET_INTERVIEW_SCHEDULE_DETAILS = "/api/v1/admin/interview/schedule"
export const UPDATE_INTERVIEW_SCHEDULE =
  "/api/v1/admin/interview/schedule/update"
export const GET_MATCHED_CANDIDATES_LIST = "/api/v1/admin/candidate/search"
export const WITHDRAWN_JOB_APPLICATION =
  "/api/v1/profile/job-application/withdrawn"
export const ENABLE_JOB_APPLICATION = "/api/v1/profile/job-application/enable"
export const JOB_APPLICATION_TIMELINE =
  "/api/v1/profile/job-application/timeline"
export const CANCEL_INTERVIEW = "/api/v1/profile/interview/cancel"
export const VERIFY_ACTION_OTP = "/api/v1/account/auth/verify-action-otp"
export const GET_INTERVIEW_APPOINTMENT_CANDIDATES =
  "/api/v1/admin/interview/schedule/invite-users/lists"
export const DELETE_INTERVIEW_APPOINTMENT_CANDIDATE =
  "/api/v1/admin/interview/schedule/invite-users/delete"
export const RESET_JOB_APPLICATION = "/api/v1/profile/reset"
export const ADD_CANDIDATE_IN_INTERVIEW =
  "/api/v1/admin/interview/schedule/invite-users/add"
export const INVITED_CANDIDATE_IMPORT =
  "/api/v1/admin/interview/schedule/invite-users/import"

// INTERVIEW
export const ASSESSMENT_LIST = "/api/v1/admin/interview/assessment/list"
export const GET_INTERVIEW_QUESTIONS = "/api/v1/admin/interview/questions"
export const GET_ASSESSMENT_DETAILS = "/api/v1/admin/interview/assessment"
export const GET_JOB_TITLES = "/api/v1/common/form-dropdown/job-titles"
export const SUBMIT_INTERVIEW_ASSESSMENT =
  "/api/v1/admin/interview/assessment/submit"
export const CHANGE_JOB_TITLE = "/api/v1/admin/interview/assessment/assign-job"
export const UPDATE_INTERVIEW_ASSESSMENT_PROMOTION =
  "/api/v1/admin/interview/assessment/update-promotion"

// COMMON
export const GET_DROPDOWN_API = "/api/v1/common/form-dropdown/lists?type=all"
export const GET_CITY_API = "/api/v1/common/form-dropdown/lists?type=cities"
export const EXPORT_BY_TYPE = "/api/v1/admin/export/by-type"
export const GET_SYSTEM_NATIONALITIES =
  "/api/v1/common/form-dropdown/system-nationalities"
export const UPDATE_COMMON_SETTINGS = "/api/v1/common/settings/update"
export const CLEAR_DASHBOARD_CACHE = "/api/v1/common/clear-cache"

// THEORETICAL TRAINING
export const GET_ALL_THEORETICAL_TRAINING =
  "/api/v1/admin/training/theoretical/lists"
export const DELETE_THEORETICAL_TRAINING = "/api/v1/admin/training/theoretical"
export const GET_TRAINING_MATERIAL_LIST =
  "/api/v1/common/form-dropdown/training-materials"
export const CREATE_THEORETICAL_TRAINING =
  "/api/v1/admin/training/theoretical/store"
export const UPDATE_THEORETICAL_TRAINING =
  "/api/v1/admin/training/theoretical/update"
export const GET_THEORETICAL_TRAINING_DETAILS =
  "/api/v1/admin/training/theoretical"
export const GET_THEORETICAL_TRAINING_PARTICIPANTS =
  "/api/v1/admin/training/theoretical/participants/lists"
export const MARK_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE =
  "/api/v1/admin/training/theoretical/participants/mark-attendance"
export const MARK_MULTIPLE_THEORETICAL_TRAINING_PARTICIPANT_ATTENDANCE =
  "/api/v1/admin/training/theoretical/participants/mark-attendance/multiple"
export const ADD_THEORETICAL_TRAINING_PARTICIPANT =
  "/api/v1/admin/training/theoretical/participants/add"
export const DELETE_THEORETICAL_TRAINING_PARTICIPANT =
  "/api/v1/admin/training/theoretical/participants/delete"
export const GET_THEORETICAL_TRAINING_PARTICIPANTS_ASSESSMENT_QUESTIONS =
  "/api/v1/profile/theoretical/assessment/questions"
export const SUBMIT_THEORETICAL_PARTICIPANT_ASSESSMENT =
  "/api/v1/profile/theoretical/assessment/submit"
export const GET_CANDIDATE_THEORETICAL_ASSESSMENT_DETAILS =
  "/api/v1/profile/theoretical/assessment"
export const GET_MATCHED_THEORETICAL_CANDIDATES =
  "/api/v1/admin/candidate/theoretical/search"
export const GET_THEORETICAL_PARTICIPANT_ASSESSMENT_DETAILS =
  "/api/v1/admin/training/theoretical/participants/assessment"
export const THEORETICAL_PARTICIPANT_OPEN_ASSESSMENT =
  "/api/v1/admin/training/theoretical/participants/assessment/openAssessment"
export const RESET_THEORETICAL_TRAINING_ASSESSMENT =
  "/api/v1/admin/training/theoretical/participants/assessment/resetAssessment"

// PRACTICAL TRAINING
export const GET_ALL_PRACTICAL_TRAINING =
  "/api/v1/admin/training/practical/lists"
export const DELETE_PRACTICAL_TRAINING = "/api/v1/admin/training/practical"
export const CREATE_PRACTICAL_TRAINING =
  "/api/v1/admin/training/practical/store"
export const UPDATE_PRACTICAL_TRAINING =
  "/api/v1/admin/training/practical/update"
export const GET_PRACTICAL_TRAINING_DETAILS = "/api/v1/admin/training/practical"
export const MARK_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE =
  "/api/v1/admin/training/practical/participants/mark-attendance"
export const GET_PRACTICAL_TRAINING_PARTICIPANTS =
  "/api/v1/admin/training/practical/participants/lists"
export const ADD_PRACTICAL_TRAINING_PARTICIPANT =
  "/api/v1/admin/training/practical/participants/add"
export const DELETE_PRACTICAL_TRAINING_PARTICIPANT =
  "/api/v1/admin/training/practical/participants/delete"
export const GET_MATCHED_PRACTICAL_CANDIDATES =
  "/api/v1/admin/candidate/practical/search"
export const MARK_MULTIPLE_PRACTICAL_TRAINING_PARTICIPANT_ATTENDANCE =
  "/api/v1/admin/training/practical/participants/mark-attendance/multiple"
export const MARK_CANDIDATE_ASSESSMENT =
  "/api/v1/admin/training/practical/participants/change-status"

//CANDIDATE PRACTICAL TRAINING
export const GET_CANDIDATE_PRACTICAL_TRAINING_AVAILABLE =
  "/api/v1/profile/practical/available"

//CANDIDATE TRIAL OPERATION
export const GET_CANDIDATE_TRIAL_OPERATIONS =
  "/api/v1/profile/trial-run-operations/available"
export const CANDIDATE_ACCEPT_TRIAL_OPERATION =
  "/api/v1/profile/trial-run-operations/accept"

// STAFF/USERS
export const GET_USER_LISTS = "/api/v1/admin/staff/drop-down/lists"
export const GET_ALL_USERS = "/api/v1/admin/staff/lists"
export const ADD_USER = "/api/v1/admin/staff/add"
export const UPDATE_USER = "/api/v1/admin/staff/update"
export const GET_USER_DETAILS = "/api/v1/admin/staff"
export const DELETE_USER = "/api/v1/admin/staff"
export const RESET_USER_PASSWORD = "/api/v1/admin/staff/change-password"
export const ASSIGN_TRIAL_OPERATION_PERMISSION =
  "/api/v1/admin/staff/permissions/assign"

// TRAINING MATERIALS
export const GET_ALL_TRAINING_MATERIALS =
  "/api/v1/admin/training/materials/lists"
export const ADD_TRAINING_MATERIAL = "/api/v1/admin/training/materials/store"
export const UPDATE_TRAINING_MATERIAL =
  "/api/v1/admin/training/materials/update"
export const GET_TRAINING_MATERIAL_DETAILS = "/api/v1/admin/training/materials"
export const DELETE_TRAINING_MATERIAL = "/api/v1/admin/training/materials"

// ROLES
export const GET_ROLES_LISTS = "/api/v1/admin/roles/all"
export const GET_ALL_ROLES_LISTS = "/api/v1/admin/roles/lists"
export const DELETE_ROLE = "/api/v1/admin/roles"
export const GET_SINGLE_ROLE = "/api/v1/admin/roles"
export const GET_PERMISSIONS = "/api/v1/admin/permissions/global/all"
export const CREATE_ROLE = "/api/v1/admin/roles/add"
export const UPDATE_ROLE = "/api/v1/admin/roles/update"
export const GET_ASSIGNED_ROLE_DATA = "/api/v1/admin/staff/permissions/get"
export const GET_CANDIATE_ROLE_DATA = "/api/v1/profile/permissions/get"

// Dashboard
export const GET_DASHBOARD_DATA = "/api/v1/admin/dashboard/statistics"

//EXPORT OPTIONS
export const EXPORT_OPTIONS_LIST = "/api/v1/admin/export-operations/lists"
export const EXPORT_OPTIONS_DELETE = "/api/v1/admin/export-operations"

// TRIAL OPERATION
export const GET_ALL_TRIAL_OPERATIONS =
  "/api/v1/admin/trial-run-operations/schedule/lists"
export const GET_TRIAL_OPERATION_DETAILS =
  "/api/v1/admin/trial-run-operations/schedule/"
export const CREATE_TRIAL_OPERATION =
  "/api/v1/admin/trial-run-operations/schedule/store"
export const UPDATE_TRIAL_OPERATION =
  "/api/v1/admin/trial-run-operations/schedule/update"
export const GET_TRIAL_OPERATION_MATCHED_CANDIDATES_LIST =
  "/api/v1/admin/candidate/trial-run-operations/search"
export const DELETE_TRIAL_OPERATION =
  "/api/v1/admin/trial-run-operations/schedule"
export const TRIAL_OPERATION_INVITE_CANDIDATES =
  "/api/v1/admin/trial-run-operations/schedule/enroll"
export const TRIAL_OPERATION_INVITE_CANDIDATES_IMPORT =
  "/api/v1/admin/trial-run-operations/schedule/enroll/import"
export const GET_STATION_SHIFT_DROPDOWN_LIST =
  "/api/v1/admin/trial-run-operations/statics"
export const MARK_TRIAL_PERIOD_ATTENDANCE =
  "/api/v1/admin/trial-run-operations/schedule/attendance"
export const TRIAL_OPERATION_CAPTURE_ABSENT =
  "/api/v1/admin/trial-run-operations/schedule/attendance/capture-absence"
export const EDIT_TRIAL_PERIOD_ATTENDANCE =
  "/api/v1/admin/trial-run-operations/schedule/edit-attendance"
export const GET_TRAINING_SCHEDULE =
  "/api/v1/admin/trial-run-operations/schedule/drop-down/lists"
export const GET_ALL_TRIAL_OPERATIONS_ATTENDANCE_LIST =
  "/api/v1/admin/trial-run-operations/schedule/attendance/lists"
export const GET_ALL_TRIAL_OPERATIONS_ENROLLMENT_LIST =
  "/api/v1/admin/trial-run-operations/schedule/invite-users/lists"
export const GET_ALL_TRIAL_OPERATIONS_REASON_LIST =
  "/api/v1/admin/trial-run-operations/schedule/attendance/reason-lists"
export const MARK_TRIAL_OPERATION_INSPECTION_ATTENDANCE =
  "/api/v1/admin/trial-run-operations/schedule/random-check"
export const GET_ALL_TRIAL_OPERATIONS_INSPECTION_LIST =
  "/api/v1/admin/trial-run-operations/schedule/random-check/lists"
export const DELETE_TRIAL_OPERATION_INSPECTION =
  "/api/v1/admin/trial-run-operations/schedule/random-check/"

// TRIAL OPERATION CATERING
export const DELETE_CATERING = "/api/v1/admin/catering"

//Catering
export const GET_CATERING_LIST = "/api/v1/admin/catering/lists"
export const ADD_CATERING = "/api/v1/admin/catering/store"
export const EDIT_DELETE_CATERING = "/api/v1/admin/catering"

//Cards
export const UPLOAD_CANDIDATES_FOR_CARDS =
  "/api/v1/admin/candidate/generate/id-cards"
export const GET_CARD_BATCHES = "/api/v1/admin/candidate/id-cards-batches"
export const GET_LIST_OF_CARDS_JOBS =
  "/api/v1/admin/candidate/id-cards/job-title"
export const GET_LIST_OF_CARDS_NOT_ISSUED =
  "/api/v1/admin/candidate/id-cards/not-issued"
export const GET_LIST_OF_CARDS_ISSUED =
  "/api/v1/admin/candidate/id-cards/issued"

//Contracts

export const GET_SIGNED_AND_UNSIGNED_CONTRACTS =
  "/api/v1/admin/candidate/contract/list"
export const GET_NOMINATED_CANDIDATES_FOR_CONTRACTS =
  "/api/v1/admin/candidate/contract/nominated-for-contract"
export const GENERATE_CONTRACTS = "/api/v1/admin/candidate/contract/generate"
export const GET_CONTRACT_BATCH_LIST =
  "/api/v1/admin/candidate/contract/batches-list"
export const ALLOW_SIGNING_CONTRACTS_FOR_BATCH =
  "/api/v1/admin/candidate/contract/allow-sign-for-all"
export const ALLOW_SIGNING_CONTRACTS_FOR_SINGLE_CANDIDATE =
  "/api/v1/admin/candidate/contract/allow-sign-for-contract"
export const GET_MY_CONTRACT = "/api/v1/profile/my-contract"
export const SIGN_THE_CONTRACT = "/api/v1/profile/sign-contract"
export const RESET_CONTRACT = "/api/v1/admin/candidate/contract/reset"
